export const CUSTOMER = 'customer';

export const EMPLOYEE_CUSTOMER = 'employee-customer';

export const EMPLOYEE = 'employee';

export const mapInputLabels = {
  [CUSTOMER]: {
    'name': 'Your Name',
    'nameLabel': 'Your Full Name',
    'phone': 'Your Phone Number',
    'email': 'Email Address',
    'zipcode': 'Zip Code'
  },
  [EMPLOYEE_CUSTOMER]: {
    'name': "Contact's Name",
    'nameLabel': "Contact's Full Name",
    'phone': 'Contact Phone Number',
    'email': 'Contact Email',
    'zipcode': 'Contact Zip Code',
    'usfEmployeeName': 'US Foods Employee Name',
    'usfEmployeeEmail': 'US Foods Employee Email'
  }
};
